import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 0.5H11.793L15.5 4.207V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5C4.948 15.5 4.5 15.052 4.5 14.5V1.5C4.5 0.948 4.948 0.5 5.5 0.5Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.788 0.5L15.5 4.223V4.5H11.5V0.5H11.788Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 14,
			height: 8,
			rx: 1.5,
			fill: "#E94E35"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.616 8.625H10.56V9.568H12.36V10.281H10.56V12H9.709V7.905H12.616V8.625Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.3 12H5.534V7.899H7.3C7.555 7.903 7.766 7.932 7.935 7.988C8.222 8.083 8.455 8.256 8.633 8.508C8.776 8.712 8.873 8.933 8.925 9.17C8.977 9.408 9.003 9.634 9.003 9.849C9.003 10.395 8.894 10.857 8.675 11.235C8.378 11.745 7.92 12 7.3 12ZM7.938 8.945C7.806 8.723 7.545 8.611 7.156 8.611H6.366V11.288H7.156C7.56 11.288 7.842 11.088 8.002 10.69C8.089 10.471 8.132 10.21 8.132 9.908C8.132 9.49 8.067 9.17 7.938 8.945Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.418 10.525H2.547V12H1.696V7.899H3.482C3.894 7.899 4.222 8.005 4.467 8.216C4.712 8.428 4.834 8.755 4.834 9.198C4.834 9.682 4.712 10.025 4.467 10.225C4.222 10.425 3.872 10.525 3.418 10.525ZM3.819 9.671C3.93 9.573 3.985 9.417 3.985 9.204C3.985 8.991 3.929 8.838 3.816 8.748C3.704 8.657 3.548 8.611 3.346 8.611H2.547V9.819H3.346C3.548 9.819 3.705 9.77 3.819 9.671Z",
			fill: "white"
		})
	]
});
export default SvgPdf;
